import React, { useEffect, useState } from 'react';
import { TextField, MenuItem } from '@mui/material';
import * as invApi from '../../lib/api/inventory';

/**
 * 창고 선택 Selectbox
 * @param {string} value - 선택된 whUuid
 * @param {function} onChange - 변경 핸들러
 * @param {string} excludeWhUuid - 제외할 창고 UUID (현재 창고)
 * @param {string} label - 라벨
 * @param {boolean} required - 필수 여부
 * @param {string} error - 에러 메시지
 */
const WarehouseSelectbox = ({
    value,
    onChange,
    excludeWhUuid,
    label = '창고 선택',
    name = 'whUuid',
    required = false,
    error,
    helperText,
    ...rest
}) => {
    const [warehouses, setWarehouses] = useState([]);

    useEffect(() => {
        const fetchWarehouses = async () => {
            try {
                const res = await invApi.getWarehouseList();
                if (res.data && res.data.list) {
                    setWarehouses(
                        res.data.list.filter((wh) =>
                            excludeWhUuid ? wh.whUuid !== excludeWhUuid : true
                        )
                    );
                }
            } catch (err) {
                console.error('창고 목록 조회 실패:', err);
            }
        };
        fetchWarehouses();
    }, [excludeWhUuid]);

    return (
        <TextField
            select
            fullWidth
            variant="outlined"
            label={label}
            name={name}
            value={value || ''}
            onChange={onChange}
            required={required}
            error={!!error}
            helperText={helperText || error}
            {...rest}
        >
            <MenuItem value="">선택하세요</MenuItem>
            {warehouses.map((wh) => (
                <MenuItem key={wh.whUuid} value={wh.whUuid}>
                    {wh.whNm}
                    {wh.whAddr ? ` (${wh.whAddr})` : ''}
                    {wh.isDefault === 'Y' ? ' [기본]' : ''}
                </MenuItem>
            ))}
        </TextField>
    );
};

export default WarehouseSelectbox;
